/**
 * PageFallback — shared Suspense fallback for lazy-loaded routes.
 *
 * Centred spinner matching the app's loading pattern. Extracted so both the
 * route table in App.tsx and the authenticated-routes boundary in
 * ProfileCompletionGate render an identical fallback.
 */

import React from 'react';
import { Spinner } from '@kantera/ui';

export const PageFallback: React.FC = () => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      minHeight: 320,
    }}
  >
    <Spinner size="lg" />
  </div>
);
